<script>
  export let user;
</script>

<svelte:head>
  {#if user}
    <title>{user.name}</title>
    <meta name="url" content="{import.meta.env['VITE_SITE_URL']}{user.profile_path}" />
    <meta property="og:title" content="{user.name} | Profile on Benable" />
    <meta property="og:description" content="Browse {user.name}'s lists of trusted recommendations" />
    <meta property="og:image" content={user.og_url} />
    <meta name="twitter:image" content={user.og_url} />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="628" />
    <meta name="twitter:site" content="@Benable_HQ" />
    <meta name="twitter:card" content="summary_large_image" />
  {/if}
</svelte:head>
